'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var camelCase = exports.camelCase = require('lodash.camelcase');
var capitalize = exports.capitalize = require('lodash.capitalize');
var endsWith = exports.endsWith = require('underscore.string/endsWith');var isBlank = exports.isBlank = require('underscore.string/isBlank');
var isFloat = exports.isFloat = require('validator').isFloat;
var isInt = exports.isInt = require('validator').isInt;
var naturalCompare = exports.naturalCompare = require('underscore.string/naturalCmp');
var padStart = exports.padStart = require('lodash.padstart');var pluralize = exports.pluralize = require('pluralize');
var snakeCase = exports.snakeCase = require('lodash.snakecase');
var startsWith = exports.startsWith = require('underscore.string/startsWith');var trimEnd = exports.trimEnd = require('lodash.trimend');
var upperFirst = exports.upperFirst = require('lodash.upperfirst');

exports.default = {
  camelCase: camelCase,
  capitalize: capitalize,
  endsWith: endsWith,
  isBlank: isBlank,
  isFloat: isFloat,
  isInt: isInt,
  naturalCompare: naturalCompare,
  padStart: padStart,
  pluralize: pluralize,
  snakeCase: snakeCase,
  startsWith: startsWith,
  trimEnd: trimEnd,
  upperFirst: upperFirst
};